import React from 'react';
import { PageHero } from '../components/PageHero';
import { FeaturedProjects } from '../components/FeaturedProjects';
export function ProjectsPage() {
  return <>
      <PageHero breadcrumb="Projects" title="Our Projects" subtitle="Transformative initiatives advancing sustainable development across Africa through global partnerships." data-id="element-336" />
      <FeaturedProjects data-id="element-337" />
    </>;
}